<template>
  <div class="tab-pane fade show active" id="nav-Recent" role="tabpanel" aria-labelledby="nav-Recent-tab">
    <div class="table-responsive">
      <a-table class="table datatable" :columns="columns" :data-source="data">
        <template #bodyCell="{ column, record }">
          <template v-if="column.key === 'Court_Name'">
            <h2 class="table-avatar">
              <a href="javascript:void(0);" class="avatar avatar-sm flex-shrink-0"><img class="avatar-img"
                  :src="require(`@/assets/img/booking/${record.Image}`)" alt="User"></a>
              <span class="table-head-name flex-grow-1">
                <a href="javascript:void(0);">{{ record.Court_Name }}</a>
                <span>{{ record.Court }}
                  <span class="book-on-date">{{ record.Booked }}</span></span>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Player_Name'">
            <h2 class="table-avatar">
              <router-link to="/coaches/my-profile" class="avatar avatar-sm flex-shrink-0"><img class="avatar-img"
                  :src="require(`@/assets/img/profiles/${record.Avatar}`)" alt="User"></router-link>
              <span class="table-head-name table-name-user flex-grow-1">
                <router-link to="/coaches/my-profile">{{ record.Player_Name }}</router-link>
              </span>
            </h2>
          </template>
          <template v-else-if="column.key === 'Date'">
            <div class="table-date-time">
              <h4>
                {{ record.Date }}<span>{{ record.Time }}</span>
              </h4>
            </div>
          </template>
          <template v-else-if="column.key === 'Amount'">
            <div><span class="pay-dark">{{ record.Amount }}</span></div>
          </template>
          <template v-else-if="column.key === 'Details'">
            <div class="text-pink view-detail-pink">
              <a href="javascript:;" data-bs-toggle="modal" data-bs-target="#cancel-court"><i
                  class="feather-eye"></i>{{ record.Details }}</a>
            </div>
          </template>
          <template v-else-if="column.key === 'action'">
            <div class="text-end">
              <div class="dropdown dropdown-action table-drop-action">
                <a href="javascript:void(0);" class="action-icon dropdown-toggle" data-bs-toggle="dropdown"
                  aria-expanded="false"><i class="fas fa-ellipsis-h"></i></a>
                <div class="dropdown-menu dropdown-menu-end">
                  <a class="dropdown-item" href="javascript:void(0);"><i class="feather-edit"></i>Edit</a>
                  <a class="dropdown-item" href="javascript:void(0);"><i class="feather-trash"></i>Delete</a>
                </div>
              </div>
            </div>
          </template>
        </template>
      </a-table>
    </div>
  </div>
</template>

<script>
const data = [
  {
    Image: "booking-01.jpg",
    Court_Name: "Wing Sports Academy",
    Court: "Court 1",
    Booked: "Booked on : 26 May 2023",
    Player_Name: "Johnson",
    Avatar: "avatar-01.jpg",
    Date: "Mon, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Cancelled: "Mon, Jul 10",
    Amount: "$140",
    Details: "View Details",
  },
  {
    Image: "booking-02.jpg",
    Court_Name: "Feather Badminton",
    Court: "Court 1",
    Booked: "Booked on : 26 May 2023",
    Player_Name: "Andy",
    Avatar: "avatar-02.jpg",
    Date: "Mon, Jul 11",
    Time: "06:00 PM - 08:00 PM",
    Cancelled: "Mon, Jul 10",
    Amount: "$150",
    Details: "View Details",
  },
];

const columns = [
  {
    title: "Court Name",
    dataIndex: "Court_Name",
    key: "Court_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Court_Name.toLowerCase();
        b = b.Court_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Player Name",
    dataIndex: "Player_Name",
    key: "Player_Name",
    sorter: {
      compare: (a, b) => {
        a = a.Player_Name.toLowerCase();
        b = b.Player_Name.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Date & Time",
    dataIndex: "Date",
    key: "Date",
    sorter: {
      compare: (a, b) => {
        a = a.Date.toLowerCase();
        b = b.Date.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Cancelled On",
    dataIndex: "Cancelled",
    sorter: {
      compare: (a, b) => {
        a = a.Cancelled.toLowerCase();
        b = b.Cancelled.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Amount",
    dataIndex: "Amount",
    key: "Amount",
    sorter: {
      compare: (a, b) => {
        a = a.Amount.toLowerCase();
        b = b.Amount.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "Details",
    dataIndex: "Details",
    key: "Details",
    sorter: {
      compare: (a, b) => {
        a = a.Details.toLowerCase();
        b = b.Details.toLowerCase();
        return a > b ? -1 : b > a ? 1 : 0;
      },
    },
  },
  {
    title: "",
    key: "action",
    sorter: true,
  },
];
export default {
  data() {
    return {
      columns,
      data,
    };
  },
};
</script>
